/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { toUrl } from '@/utils'
import { defineStore } from 'pinia'
import {
  container,
  injectable,
  instanceCachingFactory,
  registry,
  singleton
} from 'tsyringe'
import { computed, type App } from 'vue'
import { CORE_AXIOS, CORE_PLUGIN, Http } from '../../../core'
import { PLUGIN_CONSOLE_PAGE, PLUGIN_SYS_CONFIG } from '../../builtin/BuiltinPluginSymbol'
import type { ConsolePageOption, ConsolePageService, Plugin } from '../../index'
import SystemConfiguration from './views/SystemConfiguration.vue'

/**
 * 系统配置信息字段接口
 */
export interface Setting {
  /**
   * 序号
   */
  index: number
  category: null
  key: string
  /**
   * 标题
   */
  name: string
  desc: string
  /**
   * 名字
   */
  value: string
  defaultValue: null
  type: string
  /**
   * 图标
   */
  widgetSettings: {
    icon: string
  }
}

type SysConfigState = {
  settings: Setting[]
}

export interface SysConfigService {
  value(key: string): any
}

export const useSysConfig = defineStore('sysConfig', {
  state: () => ({
    settings: []
  } as SysConfigState),
  getters: {
    settingsAsMap(state): any {
      const settings: any = {}
      state.settings.forEach(s => {
        let value: any = s.value || s.defaultValue
        switch (s.type) {
          case 'boolean':
            value = value === 'true'
            break
          case 'image':
            value = toUrl(value)
            break
        }
        settings[s.key] = {
          key: s.key,
          name: s.name,
          value
        }
      })
      return settings
    }
  },
  actions: {
    async fetchSysConfig() {
      const axios = container.resolve<Http>(CORE_AXIOS)
      const res: any = await axios.get('/v1/api/sysconfig')
      this.settings = res.settings.map((s: any) => {
        if (typeof s.widgetSettings === 'string') {
          s.widgetSettings = JSON.parse(s.widgetSettings)
        }
        return s
      })
    },
    async updateSysconfig(item: any) {
      const axios = container.resolve<Http>(CORE_AXIOS)
      return axios.put(`/v1/api/sysconfig/${item.key}`, { value: item.value }).then(() => {
        this.settings = this.settings.map(s => {
          if (s.key === item.key) {
            s.value = item.value
          }
          return s
        })
        
      })
    }
  }
})

class DefaultSysConfigService implements SysConfigService {
  value(key: string) {
    const sysConfig = useSysConfig()
    return computed(() => sysConfig.settingsAsMap[key])
  }
}

@singleton()
@registry([
  {
    token: CORE_PLUGIN,
    useFactory: instanceCachingFactory<Plugin<unknown, SysConfigService>>((c) =>
      c.resolve(DefaultSystemPlugin)
    ),
  },
  {
    token: PLUGIN_SYS_CONFIG,
    useFactory: instanceCachingFactory<Plugin<unknown, SysConfigService>>((c) =>
      c.resolve(DefaultSystemPlugin)
    ),
  },
])

@injectable()
export class DefaultSystemPlugin implements Plugin<unknown, SysConfigService> {
  id: string | symbol = ''
  options: unknown
  service: SysConfigService
  constructor() {
    this.service = new DefaultSysConfigService()
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  init(app: App<Element>): void {
    const plugin =
      container.resolve<Plugin<ConsolePageOption, ConsolePageService>>(
        PLUGIN_CONSOLE_PAGE
      )
    plugin.service.addChildRoute({
      path: 'system/sysconfig',
      component: SystemConfiguration,
    })
    const sysConfig = useSysConfig()
    sysConfig.fetchSysConfig()
  }

  initialized(app: App<Element>): void {
    
  }
}
